import React, { ComponentProps } from 'react';
import { SonForm } from '../../../_lib/Form2';
import { AnyParameter } from '../../../_lib/Form2/types/SonForm';
import { SortableContentList } from '../../../_lib/components/SortableContentList';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { PageTypeRole } from '../PageTypeRoles.types';
import { DraggablePageTypeRoleItem } from '../partials/DraggablePageTypeRoleItem';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type PageTypeRolesBlockEditViewProps = {
  roles: PageTypeRole[];
  updateOrderForm: SonForm<AnyParameter>;
};

function PageTypeRolesEditView({ roles, updateOrderForm }: PageTypeRolesBlockEditViewProps) {
  const { t } = useSonTranslation('PageTypeRoles');

  if (!roles || roles.length === 0) {
    return <ContentMessage text={t('noContent')} />;
  }

  return (
    <SortableContentList items={roles} form={updateOrderForm}>
      {role => (
        <DraggablePageTypeRoleItem
          id={role.id}
          key={role.id}
          role={role}
        />
      )}
    </SortableContentList>
  );
}

export const PageTypeRolesBlockEditView = asFetchableView(PageTypeRolesEditView);
export type PageTypeRolesBlockEditView = ComponentProps<typeof PageTypeRolesBlockEditView>;
